import { Link } from "react-router-dom";

export default function Faqs() {
  return (
    <>
      <header className="relative w-full border-b border-b-black bg-gray-200 py-2">
        <section className="mx-auto max-w-[85rem]">
          <h2 className="text-center font-serif text-[110%] font-bold italic md:text-xl">
            Emergency Vehicle Technician Certification Commission
          </h2>
        </section>
      </header>
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              Frequently Asked Questions (FAQ&#8217;s)
            </h1>
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Jump to a question
            </h2>
            <ul className="my-2 ml-8 list-disc">
              <li>
                <a
                  href="#q1"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Why a certification program?
                </a>
              </li>
              <li>
                <a
                  href="#q2"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  What is the EVTCC certification program?
                </a>
              </li>
              <li>
                <a
                  href="#q3"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  What benefits are there to being certified?
                </a>
              </li>
              <li>
                <a
                  href="#q4"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Who is eligible?
                </a>
              </li>
              <li>
                <a
                  href="#q5"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  When and where are the EVTCC exams administered?
                </a>
              </li>
              <li>
                <a
                  href="#q6"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  What are the EVTCC exams like?
                </a>
              </li>
              <li>
                <a
                  href="#q7"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  How does the EVTCC certification program work?
                </a>
              </li>
              <li>
                <a
                  href="#q8"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  How to register for EVTCC examinations?
                </a>
              </li>
              <li>
                <a
                  href="#q9"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Can I take multiple tests at one event?
                </a>
              </li>
              <li>
                <a
                  href="#q10"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  How to cancel an EVT exam?
                </a>
              </li>
              <li>
                <a
                  href="#q11"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  How to become a Level I, II, or Master EVT Certified
                  Technician?
                </a>
              </li>
              <li>
                <a
                  href="#q12"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  What is ASE?
                </a>
              </li>
            </ul>
          </section>
          <section id="q1" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Why a certification program?
            </h2>
            <p className="my-2 ml-2">
              The emergency service has always ensured that response and rescue
              personnel are trained and certified to appropriate levels based on
              &ldquo;accepted standards,&rdquo; such as the NFPA standards for
              firefighters and fire officers. A great deal of emphasis is placed
              on maintaining the condition of the apparatus and equipment used
              by these personnel, but prior to EVTCC there was no formal
              recognition of specialization in all the aspects of these vehicles
              that set them apart from consumer vehicles. What level of training
              have technicians received to keep a sophisticated piece of
              machinery in proper operating order?
            </p>
            <p className="my-2 ml-2">
              Emergency vehicle technicians working in fleet services
              departments of emergency response agencies are often neglected,
              and agencies without their own fleet services departments often
              bring their vehicles to non-specialist service technicians who are
              not knowledgeable about the mission-critical systems that define
              emergency vehicles. The emergency vehicle technician role requires
              training, education, and recognition just like emergency response
              and rescue personnel. However, these needs are often unfulfilled.
              The EVT Certification Commission, Inc. was created to help meet
              those needs.
            </p>
          </section>
          <section id="q2" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              What is the EVTCC certification program?
            </h2>
            <p className="my-2 ml-2">
              The Emergency Vehicle Technician Certification Commission, Inc.
              (EVTCC) is a nonprofit corporation dedicated to improving the
              quality of emergency vehicle service and repair throughout the
              United States and Canada. EVT is governed by a Board of Directors
              that represents emergency response agencies, emergency vehicle
              maintenance service associations, and the educational community.
            </p>
            <p className="my-2 ml-2">
              EVTCC began as The Fire Apparatus Mechanics Certification Program,
              sponsored by the International Association of Fire Chiefs (IAFC).
              In 1988, the IAFC introduced this certification program in an
              effort to elevate the standards of emergency vehicle maintenance
              and the personnel who perform the work. In addition, the IAFC
              sought to provide technicians recognition for the education,
              training, and experience they have in the field of service and
              repair of emergency vehicles. While the IAFC no longer directly
              oversees the EVT Certification Program, the IAFC continues to
              support its continued development and operation.
            </p>
            <p className="my-2 ml-2">
              The primary function of EVTCC is to test and certify emergency
              vehicle technicians. We also encourage the development of
              effective training programs which address the training and
              educational needs of the emergency vehicle technician.
            </p>
          </section>
          <section id="q3" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              What benefits are there to being certified?
            </h2>
            <p className="my-2 ml-2">
              All testing and certification is on a voluntary basis. The
              benefits of being certified are personal and professional. Being
              certified as an Emergency Vehicle Technician shows departments,
              governing boards and apparatus service center customers that
              technicians have proven themselves knowledgeable in diagnosing and
              repairing emergency vehicle mechanical problems.
            </p>
            <ul className="my-2 ml-8 list-disc">
              <li>
                Being certified can potentially mean better pay, increased job
                opportunity and improved status with the technician&#8217;s
                employer.
              </li>
              <li>
                Certification can increase respect, recognition and credibility
                in the industry and profession.
              </li>
              <li>
                Technicians will have a nationally recognized certification that
                may allow both lateral as well as upward movement in the fire
                apparatus and/or ambulance maintenance field.
              </li>
              <li>
                The servicing of emergency fire apparatus and ambulances by
                certified technicians will provide more reliable equipment, thus
                enhancing the safety of the public and emergency personnel.
              </li>
              <li>
                An emergency response agency or vehicle service center employing
                certified EVT personnel will benefit by having knowledgeable
                technicians who are trained to work on emergency vehicles. This
                will influence the organization&#8217;s reputation and customer
                assurance that quality work will be performed.
              </li>
            </ul>
          </section>
          <section id="q4" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Who is eligible?
            </h2>
            <p className="my-2 ml-2">
              Anyone may register to take the examination. There are no
              prerequisites to register. The examinations have been constructed
              to identify those who possess the knowledge and skills needed to
              perform their job. The EVTCC Certification Program is structured
              for individuals to utilize independent study.
            </p>
          </section>
          <section id="q5" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              When and where are the EVTCC exams administered?
            </h2>
            <ul className="my-2 ml-8 list-disc">
              <li>
                Our nationwide test dates are in June and October. See the{" "}
                <a
                  href="https://register.evtcc.org"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  registration portal
                </a>{" "}
                or{" "}
                <Link
                  to="/exams"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Exams &amp; Prep page
                </Link>{" "}
                for more details.
              </li>
              <li>
                In addition, thoughout the rest of the year, many
                mechanics&#8217; seminars, workshops and schools (which offer
                training in various fields of maintenance) offer testing.
              </li>
            </ul>
          </section>
          <section id="q6" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              What are the EVTCC exams like?
            </h2>
            <p className="my-2 ml-2">
              Each regular EVT exam is made up of between 50 and 100
              multiple-choice questions and each re-certification exam consists
              of between 25 and 50 multiple-choice questions. The questions are
              written by a panel of technical experts from the emergency
              apparatus and ambulance industry, certified emergency vehicle
              technicians, component systems experts and vocational educators.
            </p>
            <p className="my-2 ml-2">
              Reference material lists and study objectives, on which the
              examinations are based, can be found here. These objectives should
              be used as a basis for preparing to take the EVT examinations.
              Each individual is encouraged to obtain the reference materials
              listed and review the objectives to insure that he or she is ready
              to take an EVT exam. You must receive a 70% or better to pass an
              EVT exam.
            </p>
          </section>
          <section id="q7" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              How does the EVTCC certification program work?
            </h2>
            <p className="my-2 ml-2">
              The EVTCC Certification Program offers two options for emergency
              vehicle technicians to become certified.
            </p>
            <ul className="ml-8 list-disc">
              <li>
                Option 1: Technicians may choose to take only EVT exams and
                become certified in the individual test areas. The technician
                will receive an EVT Test Certificate stating the area(s) in
                which he/she is certified.
              </li>
              <li>
                Option 2: Technicians may choose to obtain the highest EVT
                Certification by taking a combination of the EVT exams and the
                ASE (National Institute for Automotive Service Excellence)
                exams, or the appropriate Canadian Provincial License. These
                exams are used to identify the diagnostic and repair knowledge
                of vehicle maintenance and the specific levels of Emergency
                Vehicle Technician Certification. Level Certification will be
                granted to the technician who successfully completes these
                requirements. Technicians have the option of obtaining Level I,
                II, or Master EVT Technician in the Fire Apparatus, Ambulance
                Track, ARFF Vehicle Track and Law Enforcement Vehicle Track. See{" "}
                <Link
                  to="/certifications"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Certification Tracks
                </Link>{" "}
                for more information.
              </li>
            </ul>
          </section>
          <section id="q8" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              How to register for EVTCC examinations?
            </h2>
            <p className="my-2 ml-2">
              Either{" "}
              <a
                href="https://register.evtcc.org"
                className="text-(--themered) hover:text-(--darkred) hover:underline"
              >
                register online
              </a>{" "}
              or complete an{" "}
              <a
                href="/downloads/EVTCC-Exam-Registration.pdf"
                className="text-(--themered) hover:text-(--darkred) hover:underline"
              >
                EVTCC Exam Registration Form
              </a>{" "}
              and mail, email or fax it (mail a check or call to arrange
              payment) to the EVT Certification Commission. The registration
              form must be received at the EVT office at least 21 days prior to
              the scheduled exam date. There will be <em>no</em>{" "}
              &ldquo;walk-in&rdquo; registration. Confirmation of exam
              registration will be emailed to the technician within a week after
              registration is received.
            </p>
          </section>
          <section id="q9" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Can I take multiple tests at one event?
            </h2>
            <p className="my-2 ml-2">
              Yes, but there is a limit. Four hours are allotted for each
              testing event. A time limit of two hours is allowed for each
              regular exam and 40 minutes is allowed for each re-certification
              exam. Any combination of regular and/or re-certification exams
              cannot exceed four hours. For instance, in the four-hour event a
              technician could take two regular exams, or six re-certification
              exams or a combination of one regular exam and three
              re-certification exams.
            </p>
          </section>
          <section id="q10" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              How to cancel an EVT exam?
            </h2>
            <p className="my-2 ml-2">
              You must call the EVT office if you are unable to attend an exam.
            </p>
            <ul className="ml-8 list-disc">
              <li>
                Notify the EVT office at least 16 days in advance to receive a
                full refund or to transfer to a later exam date with no penalty.
              </li>
              <li>
                If you notify us 2-15 days before the exam date, a $25 charge
                fee will apply.
              </li>
              <li>
                If you notify us 1 day before the test date a $50 change will
                apply.
              </li>
              <li>
                You may forfeit your fees if you just do not show up. All of our
                proctors are volunteers and we are very concerned that they are
                not spending valuable time waiting. If you have an emergency at
                the last minute and cannot attend,{" "}
                <em>please call the proctor ASAP</em> at the number on your
                confirmation letter.
              </li>
            </ul>
          </section>
          <section id="q11" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              How to become a Level I, II, or Master EVT Certified Technician?
            </h2>
            <p className="my-2 ml-2">
              Apply for certification. Once all of the required exams, both ASE
              and EVT, for a specific level have been obtained, the technician
              will need to complete the{" "}
              <a
                href="/downloads/EVTCC-Level-Application-Form.pdf"
                className="text-(--themered) hover:text-(--darkred) hover:underline"
              >
                EVTCC Certification Level Application Form
              </a>{" "}
              (which will be sent with the letter stating that a test has been
              passed). Mail the completed application form, with copies of the
              required ASE or Canadian equivalency certificates, to the EVT
              Certification office. ASE or EVTCC exams may be taken in any
              order; however, the technician must apply for each level in
              sequence. For example, Level I requirements would have to be
              completed before applying for certification at Level II, and so
              forth. If an exam is not successfully completed, the technician
              must again register and pay the examination fees before retesting.
            </p>
          </section>
          <section id="q12" className="mt-4">
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              What is ASE?
            </h2>
            <p className="my-2 ml-2">
              The{" "}
              <a
                href="https://ase.com"
                className="text-(--themered) hover:text-(--darkred) hover:underline"
              >
                National Institute for Automotive Service Excellence
              </a>{" "}
              is another certification-offering corporation. EVTCC requires some
              of their certifications to complete Level certifications.
            </p>
            <p className="my-2 ml-2">
              ASE&#8217;s primary function is to test and certify automotive
              technicians and heavy-­duty truck technicians. The ASE program
              consists of a series of exams that measure diagnostic and repair
              knowledge and skills in various technical areas. When a technician
              passes one or more tests, and has completed two years of related
              work experience, he/she receives documentation for those areas of
              certification.
            </p>
          </section>
        </div>
      </main>
    </>
  );
}
